import React from "react";

export const CalendarTypeContext = React.createContext({});
